<template>
  <div class="box" v-loading="loading">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="card_wrap">
      <!-- <h5>{{ language("orderRecord.title") }}</h5> -->
      <div class="card">
        <div class="status">
          <status-card
            :dataArr="statusArr"
            labelWidth="0px"
            :title="language('orderRecord.queryStatus')"
            @change="changeStatus"
          ></status-card>
        </div>
        <div class="ymd">
          <ymd-card-v2
            :title="language('orderRecord.period')"
            @change="changeTime"
            startTime="startTime"
            endTime="endTime"
            select="timeType"
            :options="timeOptios"
          ></ymd-card-v2>
        </div>
        <div class="input">
          <input-card
            :title="language('orderRecord.transaction')"
            :dataArr="inputArr"
            labelPosition="top"
            @change="changeInput"
          ></input-card>
        </div>
        <!-- <div class="shop_input">
          <input-card
            :title="language('SettlementReport.transaction')"
            :dataArr="shopInputArr"
            labelPosition="top"
            @change="changeShopInput"
          ></input-card>
        </div> -->
      </div>
      <div class="tips">{{ language("orderRecord.searchTips") }}</div>
      <div class="button_wrap">
        <el-button type="primary" @click="search">{{
          language("orderRecord.search")
        }}</el-button>
      </div>
    </div>

    <div class="table_wrap">
      <div class="count_box">
        <div class="count">
          {{ language("orderRecord.results") }}: {{ results }}
          {{ language("orderRecord.rows") }}
          <template v-if="dataArr.length > 0">
            <el-button
              type="primary"
              @click="
                $utils.download2(
                  '/admin/merchant/report/exportOrderRecord',
                  form4,
                  'isGroupOrderId=1'
                )
              "
              >{{ language("all.download") }}</el-button
            >
          </template>
        </div>
        <div class="page_wrap">
          <page :total="results" @pageChange="pageChange" ref="page"></page>
        </div>
      </div>

      <cc-table
        :loadData="false"
        :config="table"
        :params="params"
        :dataArr="dataArr"
        :refeshParams="refeshTable"
        :emptyText="language('orderRecord.emptyText')"
        :showIndex="false"
        :buttonsWidth="130"
        operation="Details"
      ></cc-table>

      <el-dialog
        :close-on-click-modal="false"
        :title="language('orderRecord.view')"
        :visible.sync="dialogView"
        width="90%"
        append-to-body
      >
        <template v-if="dialogView">
          <order-record-details :viewData="viewData"></order-record-details>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import statusCard from "../../components/statusCard";
import ymdCardV2 from "../../components/ymdCardV2";
import inputCard from "../../components/inputCard";
import page from "../../components/page";
import OrderRecordDetails from "./components/OrderRecordDetails";

export default {
  components: {
    breadcrumb,
    statusCard,
    ymdCardV2,
    inputCard,
    page,
    OrderRecordDetails,
  },
  data() {
    return {
      loading: false,
      breadcrumb: {
        title: this.language("orderRecord.breadcrumbTitle"),
        list: [
          {
            name: this.language("orderRecord.breadcrumbList_1"),
          },
          {
            name: this.language("orderRecord.breadcrumbList_2"),
          },
        ],
      },
      statusArr: [
        {
          title: "",
          checkbox: [],
          list: [
            {
              name: "Delivered",
              apiName: "transactionStatus",
              value: "1",
            },
            {
              name: "Refunded",
              apiName: "transactionStatus",
              value: "4",
            },
            {
              name: "Cancel",
              apiName: "transactionStatus",
              value: "2",
            },
            {
              name: "On Hold",
              apiName: "transactionStatus",
              value: "0",
            },
            {
              name: "CSCancel",
              apiName: "transactionStatus",
              value: "3",
            },
          ],
        },
      ],
      timeOptios: [
        { label: "Delivered Date", value: "Delivered Date" },
        { label: "Order Create Date", value: "Order Create Date" },
      ],
      inputArr: [
        {
          name: "Order ID",
          apiName: "orderId",
          value: "",
        },
        {
          name: "Promotion ID",
          apiName: "promotionId",
          value: "",
        },
      ],
      shopInputArr: [
        {
          name: "Merhant ID",
          apiName: "MerhantIDID",
          value: "",
          type: "select",
          options: [],
        },
      ],
      params: {},
      refeshTable: -1,
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "mchNum",
            lable: "Master A/C",
            minWidth: 120,
          },
          {
            prop: "mchShopNum",
            minWidth: 130,
            lable: "Merhant ID",
          },
          {
            prop: "masterOrderId",
            minWidth: 150,
            lable: "Master Order ID",
          },
          {
            prop: "orderId",
            minWidth: 180,
            lable: "Order ID",
          },
          {
            prop: "wbNum",
            lable: "Waybill No.",
            minWidth: 135,
          },
          // {
          //   prop: "promotionId",
          //   lable: "Promotion Id",
          //   minWidth: 190,
          // },
          {
            prop: "orderStatusName",
            lable: "Order Status",
            minWidth: 140,
          },
          {
            prop: "transactionStatusName",
            lable: "Transaction Status",
            minWidth: 140,
            // type: "tag",
            // options: {
            //   0: {
            //     tagType: "success",
            //     text: "Delivered",
            //   },
            //   1: {
            //     tagType: "danger",
            //     text: "Refunded",
            //   },
            //   2: {
            //     tagType: "danger",
            //     text: "Cancel",
            //   },
            //   3: {
            //     tagType: "info",
            //     text: "On Hold",
            //   },
            //   4: {
            //     tagType: "danger",
            //     text: "CSCancel",
            //   },
            // },
          },
          {
            prop: "orderTime",
            lable: "Order Create Date",
            minWidth: 200,
          },
          {
            prop: "deliveredDate",
            lable: "Delivered Date",
            minWidth: 200,
          },
          {
            prop: "updateTime",
            lable: "Last Updated Date",
            minWidth: 200,
          },
          {
            prop: "saleNum",
            lable: "QTY",
            minWidth: 100,
          },
          {
            prop: "originalPrice",
            lable: "Original Sales Amount",
            minWidth: 100,
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.originalPrice, 1);
            },
          },
          {
            prop: "netSaleAmount",
            lable: "Net Sales Amount",
            minWidth: 100,
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.netSaleAmount, 1);
            },
          },
          {
            prop: "refundPrice",
            lable: "Refund Amount",
            minWidth: 100,
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.refundPrice, 1);
            },
          },
          {
            prop: "actualPrice",
            lable: "Actual Sales",
            minWidth: 100,
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.actualPrice, 1);
            },
          },
        ],
        buttons: [
          {
            name: this.language("orderRecord.view"),
            click: (row, index) => {
              this.view(row);
            },
          },
        ],
      },
      shopData: {},
      dataArr: [],
      results: 0,
      form1: {},
      form2: {},
      form3: {},
      form4: {},
      form: {
        pageSize: 10,
        pageNo: 1,
      },
      dialogView: false,
    };
  },
  methods: {
    changeStatus(e) {
      this.form1 = { ...e };
      this.svaeForm(this.form1, this.form2, this.form3);
    },
    changeTime(e) {
      console.log(e);
      if (e.timeType == "Order Create Date") {
        this.form2 = {
          geOrderTime: e.startTime,
          leOrderTime: e.endTime,
        };
      } else {
        this.form2 = {
          geDeliveredDate: e.startTime,
          leDeliveredDate: e.endTime,
        };
      }
      this.svaeForm(this.form1, this.form2, this.form3);
    },
    changeInput(e) {
      this.form3 = { ...e };
      this.svaeForm(this.form1, this.form2, this.form3);
    },
    changeShopInput(e) {},
    svaeForm(form1, form2, form3, form4) {
      this.form = {
        ...form1,
        ...form2,
        ...form3,
        ...form4,
        pageSize: this.form.pageSize,
        pageNo: this.form.pageNo,
        shopNum: this.shopData.shopNum,
        mchShopNum: this.shopData.shopNum,
      };
    },
    pageChange(e) {
      this.form.pageSize = e.pageSize;
      this.form.pageNo = e.pageNo;
      this.getData(this.form);
    },
    search() {
      console.log(this.form);
      this.form.pageSize = 10;
      this.form.pageNo = 1;
      this.$refs.page.init();
      this.getData(this.form);
    },
    getData(e) {
      this.loading = true;
      e.shopNum = this.shopData.shopNum;
      e.mchShopNum = this.shopData.shopNum;
      // this.form.shopNum = this.shopData.shopNum;
      // this.form.mchShopNum = this.shopData.shopNum;
      this.form4=e
      this.ccRequest
        .do("admin/merchant/report/getOrderRecord?isGroupOrderId=1", e)
        .then((res) => {
          this.dataArr = res.rows;
          this.results = res.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    view(e) {
      this.dialogView = true;
      this.viewData = e;
    },
  },
  mounted() {
    let shopData = this.$shopData;
    this.shopData = shopData;
    this.getData({
      pageSize: 10,
      pageNo: 1,
    });
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .status {
      flex: 1;
    }
    .ymd {
      padding-right: 20px;
      padding-left: 20px;
      flex: 1;
    }
    .input {
      width: 300px;
      flex: 1;
    }
    .shop_input {
      margin-left: 20px;
      flex: 1;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
}
.table_wrap {
  margin-top: 50px;
  .count {
    font-size: $sbuTitle;
    font-weight: 600;
  }
  .count_box {
    margin-bottom: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.button_wrap {
  margin-bottom: 20px;
}
</style>